module.exports = __webpack_public_path__ + "static/img/088.cfe3095.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/lkpy/088.png
// module id = ezvP
// module chunks = 0